import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'CCTV Installation',
        content: 'Professional installation of high-quality CCTV systems to secure your property.',
        paragraphs: [
            'Our expert technicians ensure seamless installation of CCTV cameras, providing maximum coverage for your home or business.',
            'With advanced security features, remote monitoring, and high-definition video recording, our CCTV solutions offer peace of mind and enhanced protection.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'High-definition surveillance cameras',
            'Night vision and motion detection',
            'Remote access via mobile apps',
            'Integration with alarm and security systems',
            'Professional installation and setup'
        ],
        process: [
            'Assess security needs and camera placements',
            'Select the right CCTV system',
            'Professional installation by experts',
            'Configure system settings and connectivity',
            'Provide training and post-installation support'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How long does the installation process take?',
                content: 'Installation time depends on the number of cameras and system complexity, but most setups are completed within a day.'
            },
            {
                id: 2,
                heading: 'Can I access my CCTV footage remotely?',
                content: 'Yes, our CCTV systems allow remote viewing through a mobile app or web portal.'
            },
            {
                id: 3,
                heading: 'Do you offer maintenance services?',
                content: 'Yes, we provide regular maintenance and troubleshooting to ensure your CCTV system operates efficiently.'
            },
            {
                id: 4,
                heading: 'Are the cameras weatherproof?',
                content: 'Yes, our outdoor cameras are weather-resistant and designed to withstand harsh environmental conditions.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'System Integration',
        content: 'Integrate advanced security systems, including alarms, access control, into one solution.',
        paragraphs: [
            'Our system integration services ensure seamless connectivity between CCTV cameras, alarm systems, and access control, providing a unified security solution.',
            'We design customized integration plans that allow real-time monitoring, automated responses, and centralized control for maximum efficiency and safety.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Seamless connection between security devices',
            'Centralized control for ease of management',
            'Real-time monitoring and automated alerts',
            'Compatible with smart home and business systems',
            'Scalable solutions for future expansion'
        ],
        process: [
            'Assess security needs and integration requirements',
            'Plan and design a unified security system',
            'Install and configure hardware and software',
            'Test system performance and security protocols',
            'Provide training and ongoing support'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What security systems can be integrated?',
                content: 'We integrate CCTV cameras, alarm systems, access control, intercoms, and smart security solutions into a single platform.'
            },
            {
                id: 2,
                heading: 'Can I control the system remotely?',
                content: 'Yes, our integrated security solutions offer remote access and management through mobile apps or a centralized dashboard.'
            },
            {
                id: 3,
                heading: 'Is this integration suitable for businesses and homes?',
                content: 'Absolutely! We customize integration solutions for both residential and commercial security needs.'
            },
            {
                id: 4,
                heading: 'Will I receive alerts for security breaches?',
                content: 'Yes, you will receive instant notifications via SMS, email, or app alerts for any security incidents.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Alarm Systems',
        content: 'Install and monitor state-of-the-art alarm systems for immediate response.',
        paragraphs: [
            'Our alarm systems provide real-time threat detection and instant alerts, ensuring your property remains protected 24/7.',
            'We offer tailored alarm solutions, including motion detectors, door/window sensors, and emergency response integration, to enhance security.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            '24/7 monitoring and instant alerts',
            'Integration with CCTV and access control',
            'Wireless and wired alarm system options',
            'Smartphone app for remote control',
            'Emergency response coordination'
        ],
        process: [
            'Assess security risks and alarm system needs',
            'Recommend suitable alarm solutions',
            'Install and configure alarm components',
            'Integrate alarms with existing security systems',
            'Provide monitoring services and ongoing support'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of alarm systems do you offer?',
                content: 'We offer motion detection alarms, door/window sensors, perimeter security alarms, and fire/smoke alarms.'
            },
            {
                id: 2,
                heading: 'Can I control my alarm system remotely?',
                content: 'Yes, our alarm systems come with mobile app access, allowing you to arm, disarm, and receive notifications from anywhere.'
            },
            {
                id: 3,
                heading: 'Will my alarm system work during power outages?',
                content: 'Yes, our alarm systems have backup power options to ensure continuous protection even during outages.'
            },
            {
                id: 4,
                heading: 'Do you offer professional monitoring services?',
                content: 'Yes, we provide 24/7 monitoring services, ensuring immediate response to security breaches.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Access Control',
        content: 'Manage and restrict access to secure areas with advanced access control systems for security.',
        paragraphs: [
            'Our access control systems provide a seamless way to secure your premises by restricting unauthorized entry while ensuring smooth access for authorized personnel.',
            'We offer a variety of access solutions, including biometric scanners, keycard systems, PIN-based entry, and mobile-based authentication to enhance security and convenience.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Biometric and keycard-based access systems',
            'Integration with CCTV and alarm systems',
            'Remote access management via mobile app',
            'Time-based and role-based access control',
            'Audit logs and real-time monitoring'
        ],
        process: [
            'Assess security requirements and access points',
            'Recommend the best access control solutions',
            'Install and configure access control systems',
            'Integrate access control with existing security systems',
            'Provide training and ongoing support'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of access control systems do you offer?',
                content: 'We offer biometric authentication, RFID keycards, PIN-based entry, and mobile access solutions.'
            },
            {
                id: 2,
                heading: 'Can I monitor and control access remotely?',
                content: 'Yes, our systems include mobile and web-based management for real-time access monitoring and control.'
            },
            {
                id: 3,
                heading: 'Can access control systems be integrated with CCTV and alarms?',
                content: 'Absolutely! Our systems can be fully integrated with CCTV surveillance and alarm systems for enhanced security.'
            },
            {
                id: 4,
                heading: 'Is access control suitable for small businesses?',
                content: 'Yes, we offer scalable solutions tailored for businesses of all sizes, from small offices to large enterprises.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Monitoring Services',
        content: '24/7 monitoring of your CCTV to ensure immediate response in case of an emergency.',
        paragraphs: [
            'Our professional monitoring services provide round-the-clock surveillance to detect and respond to security threats in real-time.',
            'With advanced monitoring technology, we ensure that every activity is recorded and reviewed, minimizing security risks and ensuring quick action when needed.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            '24/7 real-time CCTV monitoring',
            'Immediate response to security breaches',
            'Integration with alarm and access control systems',
            'Remote access to live surveillance feeds',
            'Detailed incident reporting and alerts'
        ],
        process: [
            'Install and configure CCTV monitoring system',
            'Connect with our 24/7 monitoring center',
            'Track live footage and detect threats',
            'Trigger alarms and emergency response if needed',
            'Provide detailed security reports and updates'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How does 24/7 monitoring enhance security?',
                content: 'Continuous monitoring ensures immediate detection of any suspicious activity, allowing for quick response to prevent security incidents.'
            },
            {
                id: 2,
                heading: 'Can I access live CCTV footage remotely?',
                content: 'Yes, you can view real-time footage from your security cameras via our mobile and web-based platforms.'
            },
            {
                id: 3,
                heading: 'What happens if a security breach is detected?',
                content: 'Our monitoring team will immediately assess the situation and take appropriate action, such as alerting security personnel or emergency responders.'
            },
            {
                id: 4,
                heading: 'Can the monitoring service be integrated with my existing security system?',
                content: 'Yes, our monitoring services can be integrated with CCTV, alarms, and access control systems for a comprehensive security solution.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Security Consultation',
        content: 'Expert advice to improve security, including risk assessments and recommendations.',
        paragraphs: [
            'Our security consultation services provide professional guidance to help you identify vulnerabilities and implement effective security measures.',
            'From risk assessments to customized security solutions, we ensure your property remains protected with the latest industry best practices.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Comprehensive security risk assessments',
            'Customized security strategies and solutions',
            'Expert recommendations for CCTV, alarms, and access control',
            'Compliance with industry security standards',
            'Guidance on security upgrades and technology integration'
        ],
        process: [
            'Conduct a thorough security assessment',
            'Identify vulnerabilities and potential threats',
            'Develop a tailored security strategy',
            'Recommend technology and security improvements',
            'Provide ongoing security consultation and updates'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Why is a security consultation important?',
                content: 'A security consultation helps identify weaknesses in your current security setup and provides expert recommendations to enhance protection.'
            },
            {
                id: 2,
                heading: 'What does a security risk assessment involve?',
                content: 'It includes evaluating physical security, access controls, surveillance systems, and identifying potential security threats.'
            },
            {
                id: 3,
                heading: 'Can you help upgrade my existing security system?',
                content: 'Yes, we provide recommendations and implementation strategies to enhance your current security setup with advanced technologies.'
            },
            {
                id: 4,
                heading: 'Do you provide security solutions for businesses and homes?',
                content: 'Yes, we offer security consultations for both residential and commercial properties, tailoring solutions to your specific needs.'
            }
        ]
    }

];

export default services;